import { createSlice } from "@reduxjs/toolkit";

const drmDailyRecordCancelSlice = createSlice({
  name: "cancelDrmtDailyRecord",
  initialState: {
    isLoading: false,
    errorMessage: undefined,
    successMessage: undefined,
  },
  reducers: {
    setCancelDrmDailyRecord: (state) => {
      state.isLoading = true;
    },
    setCancelDrmDailyRecordSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    setCancelDrmDailyRecordFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetCancelDrmDailyRecordState: (state) => {
      state.isLoading = false;
      state.errorMessage = undefined;
      state.successMessage = undefined;
    },
  },
});

export const {
  setCancelDrmDailyRecord,
  setCancelDrmDailyRecordSuccess,
  setCancelDrmDailyRecordFailure,
  resetCancelDrmDailyRecordState,
} = drmDailyRecordCancelSlice.actions;

export default drmDailyRecordCancelSlice.reducer;
